module.exports = __webpack_public_path__ + "img/code-snippet-01.2cc67634.svg";